import React from 'react';
import { icons } from 'assets/icons/index';
import { GenericModal } from 'components/Modals/GenericModal';
import { Asset } from 'types/asset';
import { Box, Horizontal } from 'gls';
import { style } from 'typestyle';
import { colours } from 'styling/colours';
import { RoundedIcon } from 'components/RoundedIcon';

type ModalProps = {
  onClose: () => void;
  onArchive: () => void;
  asset: Asset
  loading: boolean
};

const ArchiveAssetModal = (props: ModalProps) => {
  return (
    <GenericModal isOpen onClose={props.onClose} title="Archive Asset"
      roundIconStyle={false}
      icon={<RoundedIcon fillColour={colours.secondaryText}><icons.ArchiveIcon aria-label='Archive Asset' /></RoundedIcon>}
      actionName='Archive'
      onAction={props.onArchive}
      loading={props.loading}
    >
      <span>
        Are you sure you want to archive <b>{props.asset.asset_name} - {props.asset.asset_type.name}</b>?
        <Horizontal spacing={5} className={style({ marginTop: '30px' })}>
          <icons.InfoIcon aria-label="note"
            className={style({ marginTop: "3px" })}
            fill={colours.secondaryText} width='18px' height='18px'
          />
          <Box sizing="stretch">
            Please note, archived assets will not be displayed in the asset list and you cannot find
            them by searching.
          </Box>
        </Horizontal>
      </span>
    </GenericModal>
  );
};
export default ArchiveAssetModal;
